import { createSelector } from 'reselect';

export const spinnerSelector = state => state.spinner;

export const spinnerVisibleSelector = createSelector(
  spinnerSelector,
  spinner => !!spinner.spinnersCounter,
);
